<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <b-card-title>{{title}}</b-card-title>
                <b-card-title class="text-primary">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="secondary"
                        class="btn-icon"
                        size="sm"
                        :to="{name: 'dataInformasi'}"
                    >
                        <feather-icon icon="ArrowLeftIcon" />
                    </b-button>
                </b-card-title>
            </b-card-header>

            <b-card-body>
                <b-form class="needs-validation" @submit.prevent="submitForm">
                    <b-form-row>
                        <b-col
                            md="10"
                            offset-md="1"
                        >
                            <b-form-group
                                label="Kode Lokasi"
                                label-for="kodeLokasi"
                            >
                                <b-form-input
                                    id="kodeLokasi"
                                    v-model="kolokVal"
                                    disabled
                                />
                            </b-form-group>

                            <b-form-group
                                label="KIB"
                                label-for="kib"
                            >
                                <b-form-input
                                    id="kib"
                                    v-model="kibVal"
                                    disabled
                                />
                            </b-form-group>

                            <b-form-group
                                label="Kode Barang"
                                label-for="kodeBarang"
                            >
                                <b-form-input
                                    id="kodeBarang"
                                    v-model="kobarVal"
                                    disabled
                                />
                            </b-form-group>

                            <b-form-group
                                label="Nama Barang"
                                label-for="namaBarang"
                            >
                                <b-form-input
                                    id="namaBarang"
                                    v-model="nabarVal"
                                    disabled
                                />
                            </b-form-group>

                            <b-form-group
                                label="Kode Register Barang"
                                label-for="kodeRegisterBarang"
                            >
                                <b-form-input
                                    id="kodeRegisterBarang"
                                    v-model="kodeRegisterBarangVal"
                                    disabled
                                />
                            </b-form-group>

                            <b-form-group
                                label="Nilai Perolehan"
                                label-for="nilaiPerolehan"
                            >
                                <b-form-input
                                    id="nilaiPerolehan"
                                    v-model="nilaiPerolehanVal"
                                    disabled
                                />
                            </b-form-group>

                            <b-form-group
                                label="Tahun Perolehan"
                                label-for="tahunPerolehan"
                            >
                                <b-form-input
                                    id="tahunPerolehan"
                                    v-model="tahunPerolehanVal"
                                    disabled
                                />
                            </b-form-group>

                            <b-form-group
                                label="Kesesuaian Kode Barang"
                                label-for="kodeRegisterBarang"
                            >
                                <b-form-radio
                                    v-model="v$.kesesuaianKodeBarang.$model"
                                    value="1"
                                    :state="validateState(v$.kesesuaianKodeBarang)"
                                    @change="changeKesesuaianBarang"
                                >
                                    Sesuai Dengan Kode Barang
                                </b-form-radio>
                                <b-form-radio
                                    v-model="v$.kesesuaianKodeBarang.$model"
                                    value="0"
                                    :state="validateState(v$.kesesuaianKodeBarang)"
                                    @change="changeKesesuaianBarang"
                                >
                                    Tidak Sesuai Dengan Kode Barang
                                </b-form-radio>
                                <small class="text-danger" v-for="(error, index) of v$.kesesuaianKodeBarang.$errors" :key="index">
                                    <span>{{ error.$message }}</span>
                                </small>

                                <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="kesesuaianKodeBarang === '0'">
                                    <b-form-group
                                        label="KIB Seharusnya"
                                        label-for="kibSeharusnya"
                                    >
                                        <b-form-select
                                            id="kibSeharusnya"
                                            v-model="v$.kibSeharusnya.$model"
                                            :state="validateState(v$.kibSeharusnya)"
                                            :options="dataKib"
                                            @change="changeKibSeharusnya"
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.kibSeharusnya.$errors" :key="index">
                                            {{ error.$message }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    
                                    <b-form-group
                                        label="Kode Barang Yang Seharusnya"
                                        label-for="kodeBarangSeharusnya"
                                    >
                                        <v-select
                                            id="kodeBarangSeharusnya"
                                            v-model="v$.kodeBarangSeharusnya.$model"
                                            :options="dataKobar"
                                            label="text"
                                            @search="searchKodeBarangSeharusnya"
                                            @input="inputKodeBarangSeharusnya"
                                        />
                                        <small class="text-danger" v-for="(error, index) of v$.kodeBarangSeharusnya.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkSelectCostum'">Kode Barang Yang Seharusnya Harus di Isi Jika Tidak Sesuai</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </small>
                                    </b-form-group>
                                </b-col>
                            </b-form-group>

                            <b-form-group
                                label="Ukuran"
                                label-for="ukuran"
                            >
                                <b-row>
                                    <b-col cols="11">
                                        <b-form-input
                                            id="ukuran"
                                            v-model="ukuranVal"
                                            disabled
                                        />
                                    </b-col>
                                    <b-col cols="1">
                                        <label for="satuan">m2</label>
                                    </b-col>
                                    <b-col cols="11" offset-md="1" class="mt-1">
                                        <b-form-radio
                                            v-model="v$.kesesuaianUkuran.$model"
                                            value="1"
                                            :state="validateState(v$.kesesuaianUkuran)"
                                        >
                                            Sesuai Dengan Data
                                        </b-form-radio>
                                        <b-form-radio
                                            v-model="v$.kesesuaianUkuran.$model"
                                            value="0"
                                            :state="validateState(v$.kesesuaianUkuran)"
                                        >
                                            Tidak Sesuai Dengan Data
                                        </b-form-radio>
                                        <small class="text-danger" v-for="(error, index) of v$.kesesuaianUkuran.$errors" :key="index">
                                            <span>{{ error.$message }}</span>
                                        </small>

                                        <b-col cols="11" offset-md="1" class="mt-1" v-if="kesesuaianUkuran === '0'">
                                            <b-form-group
                                                label="Ukuran Seharusnya"
                                                label-for="ukuranSeharusnya"
                                            >
                                                <b-row>
                                                    <b-col cols="11">
                                                        <b-form-input
                                                            id="ukuranSeharusnya"
                                                            v-model="v$.ukuranSeharusnya.$model"
                                                            :state="validateState(v$.ukuranSeharusnya)"
                                                            @keydown="changeIntOnly"
                                                        />
                                                        <b-form-invalid-feedback v-for="(error, index) of v$.ukuranSeharusnya.$errors" :key="index">
                                                            <span v-if="error.$validator == 'checkField'">Ukuran Seharusnya Harus di Isi Jika Tidak Sesuai</span>
                                                            <span v-else>{{ error.$message }}</span>
                                                        </b-form-invalid-feedback>
                                                    </b-col>
                                                    <b-col cols="1">
                                                        <label for="satuan">m2</label>
                                                    </b-col>
                                                </b-row>
                                            </b-form-group>
                                        </b-col>
                                    </b-col>
                                </b-row>
                                
                            </b-form-group>

                            <b-form-group
                                label="Cara Perolehan/Penerimaan"
                                label-for="caraPerolehanPenerimaan"
                            >
                                <b-form-select
                                    id="caraPerolehanPenerimaan"
                                    v-model="v$.caraPerolehanPenerimaan.$model"
                                    :state="validateState(v$.caraPerolehanPenerimaan)"
                                    :options="dataCaraPerolehanPenerimaan"
                                />
                                <b-form-invalid-feedback v-for="(error, index) of v$.caraPerolehanPenerimaan.$errors" :key="index">
                                    {{ error.$message }}
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group
                                label="Apakah Bangunan Merupakan Bangunan Bertingkat ?"
                                label-for="kodeRegisterBarang"
                            >
                                <b-form-radio
                                    v-model="v$.isBertingkat.$model"
                                    value="0"
                                    :state="validateState(v$.isBertingkat)"
                                >
                                    Tidak Bertingkat
                                </b-form-radio>
                                <b-form-radio
                                    v-model="v$.isBertingkat.$model"
                                    value="1"
                                    :state="validateState(v$.isBertingkat)"
                                >
                                    Ya, Bertingkat <small class="text-warning">Bertingkat 1 Lantai adalah bangunan yang memiliki bangunan 1 tingkat di atas lantai dasar, tidak termasuk rooftop</small>
                                </b-form-radio>
                                <small class="text-danger" v-for="(error, index) of v$.isBertingkat.$errors" :key="index">
                                    <span>{{ error.$message }}</span>
                                </small>

                                <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="isBertingkat === '1'">
                                    <b-form-select
                                        id="bertingkatSeharusnya"
                                        v-model="v$.bertingkatSeharusnya.$model"
                                        :state="validateState(v$.bertingkatSeharusnya)"
                                        :options="dataBertingkatSeharusnya"
                                        @change="changeBertingkatSeharusnya"
                                    />
                                    <b-form-invalid-feedback v-for="(error, index) of v$.bertingkatSeharusnya.$errors" :key="index">
                                        <span v-if="error.$validator == 'checkField'">Bertingkat Seharusnya Harus di Isi Jika Tidak Bertingkat</span>
                                        <span v-else>{{ error.$message }}</span>
                                    </b-form-invalid-feedback>
                                </b-col>
                            </b-form-group>

                            <b-form-group
                                label="Apakah Terdapat Lantai Yang Tidak Digunakan ?"
                                label-for="isLantaiDigunakan"
                            >
                                <b-form-radio
                                    v-model="v$.isLantaiDigunakan.$model"
                                    value="1"
                                    :state="validateState(v$.isLantaiDigunakan)"
                                >
                                    Ya
                                </b-form-radio>
                                <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="isLantaiDigunakan === '1'">
                                    <b-form-group
                                        label="Jumlah Seluruh Lantai"
                                        label-for="jumlahSeluruhLantai"
                                    >
                                        <b-form-input
                                            id="jumlahSeluruhLantai"
                                            v-model="v$.jumlahSeluruhLantai.$model"
                                            :state="validateState(v$.jumlahSeluruhLantai)"
                                            disabled
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.jumlahSeluruhLantai.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkField'">Jumlah Seluruh Lantai Harus di Isi Jika Terdapat Lantai Yang Tidak Digunakan</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label="Jumlah Lantai Yang Digunakan"
                                        label-for="jumlahLantaiDigunakan"
                                    >
                                        <b-form-input
                                            id="jumlahLantaiDigunakan"
                                            v-model="v$.jumlahLantaiDigunakan.$model"
                                            :state="validateState(v$.jumlahLantaiDigunakan)"
                                            @keydown="changeIntOnly"
                                            @keyup="keyUpLantai"
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.jumlahLantaiDigunakan.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkField'">Jumlah Lantai Yang Digunakan Harus di Isi Jika Terdapat Lantai Yang Tidak Digunakan</span>
                                            <span v-else-if="error.$validator == 'checkLantai'">Jumlah Lantai Yang Digunakan Harus Lebih Kecil Dari Jumlah Seluruh Lantai</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label="Jumlah Lantai Yang Tidak Digunakan"
                                        label-for="jumlahLantaiTidakDigunakan"
                                    >
                                        <b-form-input
                                            id="jumlahLantaiTidakDigunakan"
                                            v-model="v$.jumlahLantaiTidakDigunakan.$model"
                                            :state="validateState(v$.jumlahLantaiTidakDigunakan)"
                                            disabled
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.jumlahLantaiTidakDigunakan.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkField'">Jumlah Lantai Yang Tidak Digunakan Harus di Isi Jika Terdapat Lantai Yang Tidak Digunakan</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-form-radio
                                    v-model="v$.isLantaiDigunakan.$model"
                                    value="0"
                                    :state="validateState(v$.isLantaiDigunakan)"
                                >
                                    Tidak
                                </b-form-radio>
                                <small class="text-danger" v-for="(error, index) of v$.isLantaiDigunakan.$errors" :key="index">
                                    <span>{{ error.$message }}</span>
                                </small>
                            </b-form-group>

                            <b-form-group
                                label="Jenis Beton"
                                label-for="jenisBeton"
                            >
                                <b-form-input
                                    id="jenisBeton"
                                    v-model="jenisBetonVal"
                                    disabled
                                />
                                <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                                    <b-form-radio
                                        v-model="v$.kesesuaianBahan.$model"
                                        value="1"
                                        :state="validateState(v$.kesesuaianBahan)"
                                        :disabled="jenisBetonVal ? false : true"
                                    >
                                        Sesuai Dengan Data Lama
                                    </b-form-radio>
                                    <b-form-radio
                                        v-model="v$.kesesuaianBahan.$model"
                                        value="0"
                                        :state="validateState(v$.kesesuaianBahan)"
                                        :disabled="jenisBetonVal ? false : true"
                                    >
                                        Tidak Sesuai Dengan Data Lama
                                    </b-form-radio>
                                    <small class="text-danger" v-for="(error, index) of v$.kesesuaianBahan.$errors" :key="index">
                                        <span>{{ error.$message }}</span>
                                    </small>
                                    
                                    <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="kesesuaianBahan === '0'">
                                        <b-form-select
                                            id="bahanSeharusnya"
                                            v-model="v$.bahanSeharusnya.$model"
                                            :state="validateState(v$.bahanSeharusnya)"
                                            :options="dataBahanSeharusnya"
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.bahanSeharusnya.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkField'">Bahan Seharusnya Harus di Isi Jika Tidak Sesuai</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-col>
                            </b-form-group>
                            
                            <b-form-group
                                label="SK Penggunaan"
                                label-for="skPenggunaan"
                            >
                                <b-form-radio
                                    id="skPenggunaan"
                                    v-model="v$.skPenggunaan.$model"
                                    :state="validateState(v$.skPenggunaan)"
                                    value="1"
                                >
                                    Ada SK Penggunaan
                                </b-form-radio>
                                <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="skPenggunaan === '1'">
                                    <b-form-group
                                        label="Nomor SK Penggunaan"
                                        label-for="nomorSkPenggunaan"
                                    >
                                        <b-form-input
                                            id="nomorSkPenggunaan"
                                            v-model="v$.nomorSkPenggunaan.$model"
                                            :state="validateState(v$.nomorSkPenggunaan)"
                                            @keydown="changeIntOnly"
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.nomorSkPenggunaan.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkField'">Nomor SK Penggunaan Harus di Isi Jika Ada SK Penggunaan</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group
                                        label="Tahun SK Penggunaan"
                                        label-for="tahunSkPenggunaan"
                                    >
                                        <b-form-input
                                            id="tahunSkPenggunaan"
                                            v-model="v$.tahunSkPenggunaan.$model"
                                            :state="validateState(v$.tahunSkPenggunaan)"
                                            @keydown="changeIntOnly"
                                            maxlength="4"
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.tahunSkPenggunaan.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkField'">Tahun SK Penggunaan Harus di Isi Jika Ada SK Penggunaan</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-form-radio
                                    v-model="v$.skPenggunaan.$model"
                                    :state="validateState(v$.skPenggunaan)"
                                    value="0"
                                >
                                    Tidak Ada SK Penggunaan
                                </b-form-radio>
                                <small class="text-danger" v-for="(error, index) of v$.skPenggunaan.$errors" :key="index">
                                    <span>{{ error.$message }}</span>
                                </small>
                            </b-form-group>

                            <b-form-group
                                label="Penggunaan"
                                label-for="penggunaan"
                            >
                                <b-form-select
                                    id="penggunaan"
                                    v-model="v$.penggunaan.$model"
                                    :options="dataPenggunaan"
                                    :state="validateState(v$.penggunaan)"
                                />
                                <b-form-invalid-feedback v-for="(error, index) of v$.penggunaan.$errors" :key="index">
                                    {{ error.$message }}
                                </b-form-invalid-feedback>

                                <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                                    <!-- no. 2 -->
                                    <b-form-group
                                        label="Digunakan Untuk"
                                        label-for="digunakanUntuk"
                                        v-if="penggunaan === '2'"
                                    >
                                        <b-form-input
                                            id="digunakanUntuk"
                                            v-model="v$.digunakanUntuk.$model[0].value"
                                            :state="validateState2(v$.digunakanUntuk.$each.$response.$data[0].value)"
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.digunakanUntuk.$each.$response.$errors[0].value" :key="index">
                                            <span v-if="error.$validator == 'checkField'">Digunakan Untuk Harus di Isi Jika Penggunaan Digunakan Sendiri Seluruhnya Oleh PD/UKPD</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                    <!-- no. 3 -->
                                    <div v-else-if="penggunaan === '3'">
                                        <div v-for="(item, index) of v$.pdUkpd.$model" :key="index">
                                            <b-form-group
                                                label="PD/UKPD"
                                                label-for="pdUkpd"
                                            >
                                                <b-row>
                                                    <b-col cols="11">
                                                        <v-select
                                                            v-model="item.value"
                                                            :options="dataPdUkpd"
                                                            label="text"
                                                        />
                                                    </b-col>
                                                    <b-col
                                                        cols="1"
                                                        align-self="center"
                                                        class="text-right"
                                                    >
                                                        <b-button
                                                            v-if="index == 0"
                                                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                            variant="primary"
                                                            class="btn-icon"
                                                            size="sm"
                                                            @click="() => {
                                                                pdUkpd.push(
                                                                    {
                                                                        value: defaultKolok,
                                                                    }
                                                                )
                                                                digunakanUntuk.push(
                                                                    {
                                                                        value: '',
                                                                    }
                                                                )
                                                            }"
                                                        >
                                                            <feather-icon icon="PlusIcon" />
                                                        </b-button>
                                                        <b-button
                                                            v-else
                                                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                            variant="danger"
                                                            class="btn-icon"
                                                            size="sm"
                                                            @click="() => {
                                                                pdUkpd.splice(index, 1)
                                                                digunakanUntuk.splice(index, 1)
                                                            }"
                                                        >
                                                            <feather-icon icon="MinusIcon" />
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                                <small class="text-danger" v-for="(error, index2) of v$.pdUkpd.$each.$response.$errors[index].value" :key="index2">
                                                    <span v-if="error.$validator == 'checkSelectCostum'">PD/UKPD Harus di Isi Jika Penggunaan Digunakan Seluruhnya Oleh PD/UKPD Lain</span>
                                                    <span v-else>{{ error.$message }}</span>
                                                </small>
                                            </b-form-group>

                                            <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                                                <b-form-group
                                                    label="Digunakan Untuk"
                                                    label-for="digunakanUntuk"
                                                >
                                                    <b-form-input
                                                        id="digunakanUntuk"
                                                        v-model="v$.digunakanUntuk.$model[index].value"
                                                        :state="validateState2(v$.digunakanUntuk.$each.$response.$data[index].value)"
                                                    />
                                                    <b-form-invalid-feedback v-for="(error, index2) of v$.digunakanUntuk.$each.$response.$errors[index].value" :key="index2">
                                                        <span v-if="error.$validator == 'checkField'">Digunakan Untuk Harus di Isi Jika Penggunaan Digunakan Seluruhnya Oleh PD/UKPD Lain</span>
                                                        <span v-else>{{ error.$message }}</span>
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </b-col>
                                        </div>
                                    </div>

                                    <!-- no. 4 -->
                                    <div v-else-if="penggunaan === '4'">
                                        <b-form-checkbox
                                            v-model="digunakanBersama"
                                            value="1"
                                        >
                                            PD/UKPD Lain
                                        </b-form-checkbox>
                                        <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="digunakanBersama.includes('1')">
                                            <div v-for="(item, index) of v$.pdUkpd.$model" :key="index">
                                                <b-form-group
                                                    label="PD/UKPD"
                                                    label-for="pdUkpd"
                                                >
                                                    <b-row>
                                                        <b-col cols="11">
                                                            <v-select
                                                                v-model="item.value"
                                                                label="text"
                                                                :options="dataPdUkpd"
                                                            />
                                                        </b-col>
                                                        <b-col
                                                            cols="1"
                                                            align-self="center"
                                                            class="text-right"
                                                        >
                                                            <b-button
                                                                v-if="index == 0"
                                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                                variant="primary"
                                                                class="btn-icon"
                                                                size="sm"
                                                                @click="() => {
                                                                    pdUkpd.push(
                                                                        {
                                                                            value: defaultKolok,
                                                                        }
                                                                    )
                                                                    digunakanUntuk.push(
                                                                        {
                                                                            value: '',
                                                                        }
                                                                    )
                                                                }"
                                                            >
                                                                <feather-icon icon="PlusIcon" />
                                                            </b-button>
                                                            <b-button
                                                                v-else
                                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                                variant="danger"
                                                                class="btn-icon"
                                                                size="sm"
                                                                @click="() => {
                                                                    pdUkpd.splice(index, 1)
                                                                    digunakanUntuk.splice(index, 1)
                                                                }"
                                                            >
                                                                <feather-icon icon="MinusIcon" />
                                                            </b-button>
                                                        </b-col>
                                                    </b-row>
                                                    <small class="text-danger" v-for="(error, index2) of v$.pdUkpd.$each.$response.$errors[index].value" :key="index2">
                                                        <span v-if="error.$validator == 'checkSelectCostum'">PD/UKPD Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                        <span v-else>{{ error.$message }}</span>
                                                    </small>
                                                </b-form-group>
                                                <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                                                    <b-form-group
                                                        label="Digunakan Untuk"
                                                        label-for="digunakanUntuk"
                                                    >
                                                        <b-form-input
                                                            id="digunakanUntuk"
                                                            v-model="v$.digunakanUntuk.$model[index].value"
                                                            :state="validateState2(v$.digunakanUntuk.$each.$response.$data[index].value)"
                                                        />
                                                        <b-form-invalid-feedback v-for="(error, index2) of v$.digunakanUntuk.$each.$response.$errors[index].value" :key="index2">
                                                            <span v-if="error.$validator == 'checkField'">Digunakan Untuk Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                            <span v-else>{{ error.$message }}</span>
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </b-col>
                                            </div>
                                        </b-col>
                                        <b-form-checkbox
                                            v-model="digunakanBersama"
                                            value="0"
                                        >
                                            Instansi / Pihak Lain
                                        </b-form-checkbox>
                                        <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="digunakanBersama.includes('0')">
                                            <div v-for="(item, indexx) of v$.pemanfaat.$model" :key="indexx + 'i'">
                                                <b-form-group
                                                    label="Pemanfaat"
                                                    label-for="pemanfaat"
                                                >
                                                    <b-row>
                                                        <b-col cols="11">
                                                            <b-form-select
                                                                id="pemanfaat"
                                                                v-model="item.value"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].value)"
                                                                :options="dataPemanfaat"
                                                            />
                                                        </b-col>
                                                        <b-col
                                                            cols="1"
                                                            align-self="center"
                                                            class="text-right"
                                                        >
                                                            <b-button
                                                                v-if="indexx == 0"
                                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                                variant="primary"
                                                                class="btn-icon"
                                                                size="sm"
                                                                @click="() => {
                                                                    pemanfaat.push(
                                                                        {
                                                                            value: null,
                                                                            namaPemanfaat: '',
                                                                            dasarPenggunaan: '',
                                                                            dasarPenggunaanTipe: ''
                                                                        }
                                                                    )
                                                                }"
                                                            >
                                                                <feather-icon icon="PlusIcon" />
                                                            </b-button>
                                                            <b-button
                                                                v-else
                                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                                variant="danger"
                                                                class="btn-icon"
                                                                size="sm"
                                                                @click="pemanfaat.splice(indexx, 1)"
                                                            >
                                                                <feather-icon icon="MinusIcon" />
                                                            </b-button>
                                                        </b-col>
                                                    </b-row>
                                                    <small class="text-danger" v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].value" :key="index2">
                                                        <span v-if="error.$validator == 'checkField'">Pemanfaat Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                        <span v-else>{{ error.$message }}</span>
                                                    </small>
                                                </b-form-group>
                                                <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                                                    <div v-if="pemanfaat[indexx].value === '1' || pemanfaat[indexx].value === '2'">
                                                        <b-form-group
                                                            label="Nama Pemanfaat"
                                                            label-for="namaPemanfaat"
                                                        >
                                                            <b-form-input
                                                                v-model="v$.pemanfaat.$model[indexx].namaPemanfaat"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].namaPemanfaat)"
                                                            />
                                                            <b-form-invalid-feedback v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].namaPemanfaat" :key="index2">
                                                                <span v-if="error.$validator == 'checkField'">Nama Pemanfaat Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                                <span v-else>{{ error.$message }}</span>
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                        <b-form-group
                                                            label="Dasar Penggunaan"
                                                            label-for="dasarPenggunaan"
                                                        >
                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaan"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaan)"
                                                                value="1"
                                                            >
                                                                Ada Pinjam Pakai
                                                            </b-form-radio>
                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaan"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaan)"
                                                                value="0"
                                                            >
                                                                Tidak Ada Pinjam Pakai
                                                            </b-form-radio>
                                                            <small class="text-danger" v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].dasarPenggunaan" :key="index2">
                                                                <span v-if="error.$validator == 'checkField'">Dasar Penggunaan Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                                <span v-else>{{ error.$message }}</span>
                                                            </small>
                                                        </b-form-group>
                                                    </div>

                                                    <div v-if="pemanfaat[indexx].value === '3'">
                                                        <b-form-group
                                                            label="Nama Pemanfaat"
                                                            label-for="namaPemanfaat"
                                                        >
                                                            <b-form-input
                                                                v-model="v$.pemanfaat.$model[indexx].namaPemanfaat"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].namaPemanfaat)"
                                                            />
                                                            <b-form-invalid-feedback v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].namaPemanfaat" :key="index2">
                                                                <span v-if="error.$validator == 'checkField'">Nama Pemanfaat Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                                <span v-else>{{ error.$message }}</span>
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                        <b-form-group
                                                            label="Dasar Penggunaan"
                                                            label-for="kodeRegisterBarang"
                                                        >
                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaan"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaan)"
                                                                value="1"
                                                            >
                                                                Ada Dasar Penggunaan
                                                            </b-form-radio>

                                                            <b-col cols="11" offset-md="1" v-if="pemanfaat[indexx].dasarPenggunaan === '1'">
                                                                <b-form-radio
                                                                    v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                    :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                    value="6"
                                                                >
                                                                    Sewa
                                                                </b-form-radio>
                                                                <b-form-radio
                                                                    v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                    :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                    value="5"
                                                                >
                                                                    Pinjam Pakai
                                                                </b-form-radio>
                                                                <b-form-radio
                                                                    v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                    :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                    value="4"
                                                                >
                                                                    Bangun Serah Guna
                                                                </b-form-radio>
                                                                <b-form-radio
                                                                    v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                    :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                    value="3"
                                                                >
                                                                    Bangun Guna Serah
                                                                </b-form-radio>
                                                                <b-form-radio
                                                                    v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                    :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                    value="2"
                                                                >
                                                                    KSO (Kerjasama Operasional)
                                                                </b-form-radio>
                                                                <b-form-radio
                                                                    v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                    :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                    value="1"
                                                                >
                                                                    KSPI
                                                                </b-form-radio>
                                                                <small class="text-danger" v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].dasarPenggunaanTipe" :key="index2">
                                                                    <span v-if="error.$validator == 'checkField'">Dasar Penggunaan Tipe Harus di Isi Jika Ada Dasar Penggunaan</span>
                                                                    <span v-else>{{ error.$message }}</span>
                                                                </small>
                                                            </b-col>

                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaan"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaan)"
                                                                value="0"
                                                            >
                                                                Tidak Ada Dasar Penggunaan
                                                            </b-form-radio>
                                                            <small class="text-danger" v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].dasarPenggunaan" :key="index2">
                                                                <span v-if="error.$validator == 'checkField'">Dasar Penggunaan Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                                <span v-else>{{ error.$message }}</span>
                                                            </small>
                                                        </b-form-group>
                                                    </div>
                                                </b-col>
                                            </div>
                                        </b-col>
                                    </div>
                                    
                                    <!-- no. 5 -->
                                    <div v-else-if="penggunaan === '5'">
                                        <div v-for="(item, indexx) of v$.pemanfaat.$model" :key="indexx + 'i'">
                                            <b-form-group
                                                label="Pemanfaat"
                                                label-for="pemanfaat"
                                            >
                                                <b-row>
                                                    <b-col cols="11">
                                                        <b-form-select
                                                            id="pemanfaat"
                                                            v-model="item.value"
                                                            :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].value)"
                                                            :options="dataPemanfaat"
                                                        />
                                                    </b-col>
                                                    <b-col
                                                        cols="1"
                                                        align-self="center"
                                                        class="text-right"
                                                    >
                                                        <b-button
                                                            v-if="indexx == 0"
                                                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                            variant="primary"
                                                            class="btn-icon"
                                                            size="sm"
                                                            @click="() => {
                                                                pemanfaat.push(
                                                                    {
                                                                        value: null,
                                                                        namaPemanfaat: '',
                                                                        dasarPenggunaan: '',
                                                                        dasarPenggunaanTipe: ''
                                                                    }
                                                                )
                                                            }"
                                                        >
                                                            <feather-icon icon="PlusIcon" />
                                                        </b-button>
                                                        <b-button
                                                            v-else
                                                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                            variant="danger"
                                                            class="btn-icon"
                                                            size="sm"
                                                            @click="pemanfaat.splice(indexx, 1)"
                                                        >
                                                            <feather-icon icon="MinusIcon" />
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                                <small class="text-danger" v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].value" :key="index2">
                                                    <span v-if="error.$validator == 'checkField'">Pemanfaat Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                    <span v-else>{{ error.$message }}</span>
                                                </small>
                                            </b-form-group>
                                            <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                                                <div v-if="pemanfaat[indexx].value === '1' || pemanfaat[indexx].value === '2'">
                                                    <b-form-group
                                                        label="Nama Pemanfaat"
                                                        label-for="namaPemanfaat"
                                                    >
                                                        <b-form-input
                                                            v-model="v$.pemanfaat.$model[indexx].namaPemanfaat"
                                                            :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].namaPemanfaat)"
                                                        />
                                                        <b-form-invalid-feedback v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].namaPemanfaat" :key="index2">
                                                            <span v-if="error.$validator == 'checkField'">Nama Pemanfaat Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                            <span v-else>{{ error.$message }}</span>
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                    <b-form-group
                                                        label="Dasar Penggunaan"
                                                        label-for="dasarPenggunaan"
                                                    >
                                                        <b-form-radio
                                                            v-model="v$.pemanfaat.$model[indexx].dasarPenggunaan"
                                                            :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaan)"
                                                            value="1"
                                                        >
                                                            Ada Pinjam Pakai
                                                        </b-form-radio>
                                                        <b-form-radio
                                                            v-model="v$.pemanfaat.$model[indexx].dasarPenggunaan"
                                                            :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaan)"
                                                            value="0"
                                                        >
                                                            Tidak Ada Pinjam Pakai
                                                        </b-form-radio>
                                                        <small class="text-danger" v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].dasarPenggunaan" :key="index2">
                                                            <span v-if="error.$validator == 'checkField'">Dasar Penggunaan Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                            <span v-else>{{ error.$message }}</span>
                                                        </small>
                                                    </b-form-group>
                                                </div>

                                                <div v-if="pemanfaat[indexx].value === '3'">
                                                    <b-form-group
                                                        label="Nama Pemanfaat"
                                                        label-for="namaPemanfaat"
                                                    >
                                                        <b-form-input
                                                            v-model="v$.pemanfaat.$model[indexx].namaPemanfaat"
                                                            :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].namaPemanfaat)"
                                                        />
                                                        <b-form-invalid-feedback v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].namaPemanfaat" :key="index2">
                                                            <span v-if="error.$validator == 'checkField'">Nama Pemanfaat Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                            <span v-else>{{ error.$message }}</span>
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                    <b-form-group
                                                        label="Dasar Penggunaan"
                                                        label-for="kodeRegisterBarang"
                                                    >
                                                        <b-form-radio
                                                            v-model="v$.pemanfaat.$model[indexx].dasarPenggunaan"
                                                            :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaan)"
                                                            value="1"
                                                        >
                                                            Ada Dasar Penggunaan
                                                        </b-form-radio>

                                                        <b-col cols="11" offset-md="1" v-if="pemanfaat[indexx].dasarPenggunaan === '1'">
                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                value="6"
                                                            >
                                                                Sewa
                                                            </b-form-radio>
                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                value="5"
                                                            >
                                                                Pinjam Pakai
                                                            </b-form-radio>
                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                value="4"
                                                            >
                                                                Bangun Serah Guna
                                                            </b-form-radio>
                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                value="3"
                                                            >
                                                                Bangun Guna Serah
                                                            </b-form-radio>
                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                value="2"
                                                            >
                                                                KSO (Kerjasama Operasional)
                                                            </b-form-radio>
                                                            <b-form-radio
                                                                v-model="v$.pemanfaat.$model[indexx].dasarPenggunaanTipe"
                                                                :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaanTipe)"
                                                                value="1"
                                                            >
                                                                KSPI
                                                            </b-form-radio>
                                                            <small class="text-danger" v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].dasarPenggunaanTipe" :key="index2">
                                                                <span v-if="error.$validator == 'checkField'">Dasar Penggunaan Tipe Harus di Isi Jika Ada Dasar Penggunaan</span>
                                                                <span v-else>{{ error.$message }}</span>
                                                            </small>
                                                        </b-col>

                                                        <b-form-radio
                                                            v-model="v$.pemanfaat.$model[indexx].dasarPenggunaan"
                                                            :state="validateState2(v$.pemanfaat.$each.$response.$data[indexx].dasarPenggunaan)"
                                                            value="0"
                                                        >
                                                            Tidak Ada Dasar Penggunaan
                                                        </b-form-radio>
                                                        <small class="text-danger" v-for="(error, index2) of v$.pemanfaat.$each.$response.$errors[indexx].dasarPenggunaan" :key="index2">
                                                            <span v-if="error.$validator == 'checkField'">Dasar Penggunaan Harus di Isi Jika Penggunaan Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain</span>
                                                            <span v-else>{{ error.$message }}</span>
                                                        </small>
                                                    </b-form-group>
                                                </div>
                                            </b-col>
                                        </div>
                                    </div>
                                </b-col>
                            </b-form-group>

                            <b-form-group
                                label="Gedung Dan Bangunan Di Atas Tanah Milik"
                                label-for="gedungBangunanTanahMilik"
                            >
                                <b-form-select
                                    id="gedungBangunanTanahMilik"
                                    v-model="v$.gedungBangunanTanahMilik.$model"
                                    :state="validateState(v$.gedungBangunanTanahMilik)"
                                    :options="dataGedungBangunanTanahMilik"
                                />
                                <b-form-invalid-feedback v-for="(error, index) of v$.gedungBangunanTanahMilik.$errors" :key="index">
                                    {{ error.$message }}
                                </b-form-invalid-feedback>
                                <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="gedungBangunanTanahMilik === '1'">
                                    <b-form-group
                                        label="PD/UKPD"
                                        label-for="gedungBangunanTanahMilikPdUkpd"
                                    >
                                        <v-select
                                            id="gedungBangunanTanahMilikPdUkpd"
                                            v-model="v$.gedungBangunanTanahMilikPdUkpd.$model"
                                            :options="dataPdUkpd"
                                            label="text"
                                            @input="inputGedungBangunanTanahMilikPdUkpd"
                                        />
                                        <small class="text-danger" v-for="(error, index) of v$.gedungBangunanTanahMilikPdUkpd.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkSelectCostum'">PD/UKPD Harus di Isi Jika Pemerintah Daerah Provinsi DKI Jakarta</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </small>
                                    </b-form-group>

                                    <b-form-group
                                        label="Kode Barang"
                                        label-for="gedungBangunanTanahMilikKobar"
                                    >
                                        <v-select
                                            id="gedungBangunanTanahMilikKobar"
                                            v-model="v$.gedungBangunanTanahMilikKobar.$model"
                                            :state="validateState(v$.gedungBangunanTanahMilikKobar)"
                                            :options="dataGedungBangunanTanahMilikKobar"
                                            label="text"
                                            @search="searchIndikasiGandaKobar"
                                            @input="inputGedungBangunanTanahMilikKobar"
                                        />
                                        <small class="text-danger" v-for="(error, index) of v$.gedungBangunanTanahMilikKobar.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkSelectCostum'">Kode Barang Harus di Isi Jika Pemerintah Daerah Provinsi DKI Jakarta</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </small>
                                    </b-form-group>

                                    <b-form-group
                                        label="Register"
                                        label-for="gedungBangunanTanahMilikRegister"
                                    >
                                        <b-form-select
                                            id="gedungBangunanTanahMilikRegister"
                                            v-model="v$.gedungBangunanTanahMilikRegister.$model"
                                            :state="validateState(v$.gedungBangunanTanahMilikRegister)"
                                            :options="dataGedungBangunanTanahMilikRegister"
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.gedungBangunanTanahMilikRegister.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkField'">Register Harus di Isi Jika Pemerintah Daerah Provinsi DKI Jakarta</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="gedungBangunanTanahMilik === '2' || gedungBangunanTanahMilik === '3' || gedungBangunanTanahMilik === '4'">
                                    <b-form-group
                                        label="Sebutkan"
                                        label-for="gedungBangunanTanahMilikSebutkan"
                                    >
                                        <b-form-input
                                            id="gedungBangunanTanahMilikSebutkan"
                                            v-model="v$.gedungBangunanTanahMilikSebutkan.$model"
                                            :state="validateState(v$.gedungBangunanTanahMilikSebutkan)"
                                        />
                                        <b-form-invalid-feedback v-for="(error, index) of v$.gedungBangunanTanahMilikSebutkan.$errors" :key="index">
                                            <span v-if="error.$validator == 'checkField'">Sebutkan Harus di Isi</span>
                                            <span v-else>{{ error.$message }}</span>
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-form-group>

                            <b-form-group
                                label="Alamat"
                                label-for="alamat"
                            >
                                <b-form-textarea
                                    id="alamat"
                                    v-model="alamatVal"
                                    disabled
                                />

                                <b-col cols="11" offset-md="1" class="mt-1 pr-0">

                                    <div v-if="kesesuaianAlamat === '0'">
                                        <b-form-group
                                            label="Kabupaten/Kota"
                                            label-for="kabKota"
                                            class="mt-1"
                                        >
                                            <b-form-select
                                                id="kabKota"
                                                v-model="v$.kabKota.$model"
                                                :state="validateState(v$.kabKota)"
                                                :options="dataKabKota"
                                                @change="changeKabKota"
                                            />
                                            <b-form-invalid-feedback v-for="(error, index) of v$.kabKota.$errors" :key="index">
                                                <span v-if="error.$validator == 'checkField'">Kabupaten/Kota Harus di Isi Jika Tidak Sesuai Dengan Data Lama</span>
                                                <span v-else>{{ error.$message }}</span>
                                            </b-form-invalid-feedback>
                                        </b-form-group>

                                        <b-form-group
                                            label="Kecamatan"
                                            label-for="kecamatan"
                                        >
                                            <b-form-select
                                                id="kecamatan"
                                                v-model="v$.kecamatan.$model"
                                                :state="validateState(v$.kecamatan)"
                                                :options="dataKecamatan"
                                                @change="changeKecamatan"
                                            />
                                            <b-form-invalid-feedback v-for="(error, index) of v$.kecamatan.$errors" :key="index">
                                                <span v-if="error.$validator == 'checkField'">Kecamatan Harus di Isi Jika Tidak Sesuai Dengan Data Lama</span>
                                                <span v-else>{{ error.$message }}</span>
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-form-group
                                            label="Kelurahan"
                                            label-for="kelurahan"
                                        >
                                            <b-form-select
                                                id="kelurahan"
                                                v-model="v$.kelurahan.$model"
                                                :state="validateState(v$.kelurahan)"
                                                :options="dataKelurahan"
                                                @change="changeKelurahan"
                                            />
                                            <b-form-invalid-feedback v-for="(error, index) of v$.kelurahan.$errors" :key="index">
                                                <span v-if="error.$validator == 'checkField'">Kelurahan Harus di Isi Jika Tidak Sesuai Dengan Data Lama</span>
                                                <span v-else>{{ error.$message }}</span>
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-form-group
                                            label="Jalan"
                                            label-for="jalan"
                                        >
                                            <b-form-input
                                                id="jalan"
                                                v-model="v$.jalan.$model"
                                                :state="validateState(v$.jalan)"
                                            />
                                            <b-form-invalid-feedback v-for="(error, index) of v$.jalan.$errors" :key="index">
                                                <span v-if="error.$validator == 'checkField'">Jalan Harus di Isi Jika Tidak Sesuai Dengan Data Lama</span>
                                                <span v-else>{{ error.$message }}</span>
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-row>
                                            <b-col cols="2">
                                                <b-form-group
                                                    label="No"
                                                    label-for="noAlamat"
                                                >
                                                    <b-form-input
                                                        id="noAlamat"
                                                        v-model="v$.noAlamat.$model"
                                                        :state="validateState(v$.noAlamat)"
                                                    />
                                                    <b-form-invalid-feedback v-for="(error, index) of v$.noAlamat.$errors" :key="index">
                                                        <span v-if="error.$validator == 'checkField'">No Harus di Isi Jika Tidak Sesuai Dengan Data Lama</span>
                                                        <span v-else>{{ error.$message }}</span>
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="2">
                                                <b-form-group
                                                    label="RT"
                                                    label-for="rt"
                                                >
                                                    <b-form-input
                                                        id="rt"
                                                        v-model="v$.rt.$model"
                                                        :state="validateState(v$.rt)"
                                                        @keydown="changeIntOnly"
                                                    />
                                                    <b-form-invalid-feedback v-for="(error, index) of v$.rt.$errors" :key="index">
                                                        <span v-if="error.$validator == 'checkField'">RT Harus di Isi Jika Tidak Sesuai Dengan Data Lama</span>
                                                        <span v-else>{{ error.$message }}</span>
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="2">
                                                <b-form-group
                                                    label="RW"
                                                    label-for="rw"
                                                >
                                                    <b-form-input
                                                        id="rw"
                                                        v-model="v$.rw.$model"
                                                        :state="validateState(v$.rw)"
                                                        @keydown="changeIntOnly"
                                                    />
                                                    <b-form-invalid-feedback v-for="(error, index) of v$.rw.$errors" :key="index">
                                                        <span v-if="error.$validator == 'checkField'">RW Harus di Isi Jika Tidak Sesuai Dengan Data Lama</span>
                                                        <span v-else>{{ error.$message }}</span>
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="6">
                                                <b-form-group
                                                    label="Kode Pos"
                                                    label-for="kodePos"
                                                >
                                                    <b-form-input
                                                        id="kodePos"
                                                        v-model="v$.kodePos.$model"
                                                        :state="validateState(v$.kodePos)"
                                                        disabled
                                                    />
                                                    <b-form-invalid-feedback v-for="(error, index) of v$.kodePos.$errors" :key="index">
                                                        <span v-if="error.$validator == 'checkField'">Kode Pos Harus di Isi Jika Tidak Sesuai Dengan Data Lama</span>
                                                        <span v-else>{{ error.$message }}</span>
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                            </b-form-group>

                            <b-form-group
                                label="Indikasi Tercatat Ganda"
                                label-for="isIndikasiGanda"
                            >
                                <b-form-radio
                                    v-model="v$.isIndikasiGanda.$model"
                                    :state="validateState(v$.isIndikasiGanda)"
                                    value="1"
                                >
                                    Terindikasi Tercatat Ganda Dengan
                                </b-form-radio>
                                <b-col cols="11" offset-md="1" class="mt-1 pr-0" v-if="isIndikasiGanda === '1'">
                                    <b-form-select
                                        id="indikasiGandaDengan"
                                        v-model="v$.indikasiGandaDengan.$model"
                                        :state="validateState(v$.indikasiGandaDengan)"
                                        :options="dataIndikasiGandaDengan"
                                        @change="changeIndikasiGandaDengan"
                                    />
                                    <b-form-invalid-feedback v-for="(error, index) of v$.indikasiGandaDengan.$errors" :key="index">
                                        <span v-if="error.$validator == 'checkField'">Indikasi Ganda Harus di Isi Jika Terindikasi Tercatat Ganda</span>
                                        <span v-else>{{ error.$message }}</span>
                                    </b-form-invalid-feedback>

                                    <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                                        <b-form-group
                                            label="Sebutkan"
                                            label-for="indikasiGandaSebutkan"
                                            v-if="indikasiGandaDengan === '1' || indikasiGandaDengan === '2'"
                                        >
                                            <b-form-input
                                                id="indikasiGandaSebutkan"
                                                v-model="v$.indikasiGandaSebutkan.$model"
                                                :state="validateState(v$.indikasiGandaSebutkan)"
                                            />
                                            <b-form-invalid-feedback v-for="(error, index) of v$.indikasiGandaSebutkan.$errors" :key="index">
                                                <span v-if="error.$validator == 'checkField'">Sebutkan Harus di Isi Jika Terindikasi Tercatat Ganda Dengan Pemerintah Pusat Atau Pemerintah Daerah Lain</span>
                                                <span v-else>{{ error.$message }}</span>
                                            </b-form-invalid-feedback>
                                        </b-form-group>

                                        <div v-if="indikasiGandaDengan === '3'">
                                            <b-form-group
                                                label=""
                                                label-for="indikasiGandaPdUkpd"
                                            >
                                                <v-select
                                                    id="indikasiGandaPdUkpd"
                                                    v-model="v$.indikasiGandaPdUkpd.$model"
                                                    :state="validateState(v$.indikasiGandaPdUkpd)"
                                                    :options="dataIndikasiGandaPdUkpd"
                                                    label="text"
                                                />
                                                <small class="text-danger" v-for="(error, index) of v$.indikasiGandaPdUkpd.$errors" :key="index">
                                                    <span v-if="error.$validator == 'checkSelectCostum'">PD/UKPD Harus di Isi Jika Terindikasi Tercatat Ganda Dengan PD/UKPD</span>
                                                    <span v-else>{{ error.$message }}</span>
                                                </small>
                                            </b-form-group>

                                            <b-form-group
                                                label="Kode Barang"
                                                label-for="indikasiGandaKobar"
                                            >
                                                <v-select
                                                    id="indikasiGandaKobar"
                                                    v-model="v$.indikasiGandaKobar.$model"
                                                    :state="validateState(v$.indikasiGandaKobar)"
                                                    :options="dataKobar"
                                                    label="text"
                                                    @search="searchIndikasiGandaKobar"
                                                    @input="inputIndikasiGandaKobar"
                                                />
                                                <small class="text-danger" v-for="(error, index) of v$.indikasiGandaKobar.$errors" :key="index">
                                                    <span v-if="error.$validator == 'checkSelectCostum'">Kode Barang Harus di Isi Jika Terindikasi Tercatat Ganda Dengan PD/UKPD</span>
                                                    <span v-else>{{ error.$message }}</span>
                                                </small>
                                            </b-form-group>

                                            <b-form-group
                                                label="Register"
                                                label-for="indikasiGandaRegister"
                                            >
                                                <b-form-select
                                                    id="indikasiGandaRegister"
                                                    v-model="v$.indikasiGandaRegister.$model"
                                                    :state="validateState(v$.indikasiGandaRegister)"
                                                    :options="dataIndikasiGandaRegister"
                                                />
                                                <b-form-invalid-feedback v-for="(error, index) of v$.indikasiGandaRegister.$errors" :key="index">
                                                    <span v-if="error.$validator == 'checkField'">Register Harus di Isi Jika Terindikasi Tercatat Ganda Dengan PD/UKPD</span>
                                                    <span v-else>{{ error.$message }}</span>
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                    </b-col>
                                </b-col>
                                <b-form-radio
                                    v-model="v$.isIndikasiGanda.$model"
                                    :state="validateState(v$.isIndikasiGanda)"
                                    value="0"
                                >
                                    Tidak Tercatat Ganda
                                </b-form-radio>
                                <small class="text-danger" v-for="(error, index) of v$.isIndikasiGanda.$errors" :key="index">
                                    {{ error.$message }}
                                </small>
                            </b-form-group>

                            <b-form-group
                                label="Catatan"
                                label-for="catatan"
                                v-if="statusPersetujuanVal === '0'"
                            >
                                <label for="catatanValue" class="font-weight-bolder">{{catatanVal}}</label>
                            </b-form-group>

                            <b-col
                                cols="12"
                                class="text-right pr-0 pt-2"
                            >
                                <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    type="submit"
                                    variant="primary"
                                >
                                    <div v-if="isSubmit">
                                        <b-spinner small />
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <div v-else>Simpan</div>
                                </b-button>
                            </b-col>
                        </b-col>
                    </b-form-row>
                </b-form>
            </b-card-body>
        </b-card>
    </div>
  
</template>

<script>
import {
    BCard, BForm, BFormRow, BCol, BFormInput, BFormValidFeedback, BFormInvalidFeedback, BCardHeader, BCardBody, BButton, BFormGroup, BCardTitle, BSpinner, BFormSelect, BTable, BRow, BFormTextarea
} from 'bootstrap-vue'
import { required, helpers } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import {ref, computed, watchEffect, watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
const moment = require('moment');
import dataInformasi from '@/composables/dataInformasi'
import {setInputIntOnly} from '@/libs/helper'
import master from '@/composables/master'

export default {
    props: {
        kolokVal: String,
        kibVal: String,
        kobarVal: String,
        nabarVal: String,
        kodeRegisterBarangVal: String,
        nilaiPerolehanVal: String,        
        tahunPerolehanVal: String,
        ukuranVal: String,
        jenisBetonVal: String,
        alamatVal: String,
        rekonKodeVal: String,
        rekonTahunVal: String,

        kesesuaianKodeBarangVal: String,
        kibSeharusnyaVal: String,
        kodeBarangSeharusnyaVal: String,
        kesesuaianUkuranVal:String,
        ukuranSeharusnyaVal:String,
        caraPerolehanPenerimaanVal:String,
        isBertingkatVal:String,
        bertingkatSeharusnyaVal:String,
        jumlahSeluruhLantaiVal:String,
        isLantaiDigunakanVal:String,
        jumlahLantaiTidakDigunakanVal:String,
        jumlahLantaiDigunakanVal:String,
        kesesuaianBahanVal: String,
        bahanSeharusnyaVal: String,
        skPenggunaanVal: String,
        nomorSkPenggunaanVal: String,
        tahunSkPenggunaanVal: String,
        penggunaanVal: String,
        digunakanBersamaVal: Array,
        digunakanUntukVal: Array,
        pdUkpdVal: Array,
        pemanfaatVal: Array,
        gedungBangunanTanahMilikVal: String,
        gedungBangunanTanahMilikPdUkpdVal: Object,
        gedungBangunanTanahMilikKobarVal: Object,
        gedungBangunanTanahMilikRegisterVal: String,
        gedungBangunanTanahMilikSebutkanVal: String,
        kabKotaVal: String,
        kecamatanVal: String,
        kelurahanVal: String,
        jalanVal: String,
        noAlamatVal: String,
        rtVal: String,
        rwVal: String,
        kodePosVal: String,
        isIndikasiGandaVal: String,
        indikasiGandaDenganVal: String,
        indikasiGandaSebutkanVal: String,
        indikasiGandaPdUkpdVal: Object,
        indikasiGandaKobarVal: Object,
        indikasiGandaRegisterVal: String,
        statusPersetujuanVal: String,
        catatanVal: String,
        
        isShowUbahVal: Boolean,

        title: String,
        id: String,
    },
    setup(props, context){
        const g = context.root

        var isSubmit = ref(false)
        const router = g.$router
        const $http = g.$http

        var now = moment().format('YYYY-MM-DD')
        var momenNow = moment();
        var tahunNow = ref(moment().format('YYYY'))

        var cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))
        let defaultKolok = ref({text: '-- Pilih Salah Satu --', value: null})
        if(cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F'){
            var cookiesKolok = ref(g.$cookies.get('kolok'))
            var cookiesNalok = ref(g.$cookies.get('nalok'))
            defaultKolok.value = {text: `${cookiesKolok.value}::${cookiesNalok.value}`, value: cookiesKolok.value}
        }

        //form name
        var kesesuaianKodeBarang = ref('')
        var kodeBarangSeharusnya = ref({text: '-- Pilih Salah Satu --', value: null})
        var kibSeharusnya = ref(null)
        var namaBarangSeharusnya = ref('')
        var kesesuaianUkuran = ref('')
        var ukuranSeharusnya = ref('')
        var caraPerolehanPenerimaan = ref(null)
        var isBertingkat = ref('')
        var bertingkatSeharusnya = ref(null)
        var isLantaiDigunakan = ref(null)
        var jumlahSeluruhLantai = ref('')
        var jumlahLantaiDigunakan = ref('')
        var jumlahLantaiTidakDigunakan = ref('')
        var kesesuaianBahan = ref('')
        var bahanSeharusnya = ref(null)
        var skPenggunaan = ref('')
        var nomorSkPenggunaan = ref('')
        var tahunSkPenggunaan = ref('')
        var penggunaan = ref(null)
        var digunakanBersama = ref([])
        // var digunakanUntuk = ref('')
        // var pdUkpd = ref({text: '-- Pilih Salah Satu --', value: null})
        var pdUkpd = ref([
            {
                value: defaultKolok.value,
            },
        ])
        var digunakanUntuk = ref([
            {
                value: ''
            },
        ])
        // var pemanfaat = ref(null)
        var pemanfaat = ref([
            {
                value: null,
                namaPemanfaat: '',
                dasarPenggunaan: '',
                dasarPenggunaanTipe: ''
            },
        ])
        // var namaPemanfaat = ref('')
        // var dasarPenggunaan = ref('')
        // var dasarPenggunaanTipe = ref('')
        var gedungBangunanTanahMilik = ref(null)
        var gedungBangunanTanahMilikPdUkpd = ref(defaultKolok.value)
        var gedungBangunanTanahMilikKobar = ref({text: '-- Pilih Salah Satu --', value: null})
        var gedungBangunanTanahMilikRegister = ref(null)
        var gedungBangunanTanahMilikSebutkan = ref('')
        var kesesuaianAlamat = ref('0')
        var kabKota = ref(null)
        var kecamatan = ref(null)
        var kelurahan = ref(null)
        var jalan = ref('')
        var noAlamat = ref('')
        var rt = ref('')
        var rw = ref('')
        var kodePos = ref('')
        var isIndikasiGanda = ref('')
        var indikasiGandaDengan = ref(null)
        var indikasiGandaSebutkan = ref('')
        var indikasiGandaPdUkpd = ref(defaultKolok.value)
        var indikasiGandaKobar = ref({text: '-- Pilih Salah Satu --', value: null})
        var indikasiGandaRegister = ref(null)

        var dataCaraPerolehanPenerimaan = ref([])
        var dataKib = ref([])
        var dataKobar = ref([])
        var dataBertingkatSeharusnya = ref([])
        var dataBahanSeharusnya = ref([
            {value: null, text: '-- Pilih Salah Satu --'},
            {value: '0', text: 'Bukan Beton'},
            {value: '1', text: 'Beton'},
            {value: '2', text: 'Campuran'},
        ])
        var dataPenggunaan = ref([
            {value: null, text: '-- Pilih Salah Satu --'},
            {value: '1', text: 'Tidak Digunakan'},
            {value: '2', text: 'Digunakan Sendiri Seluruhnya Oleh PD/UKPD'},
            {value: '3', text: 'Digunakan Seluruhnya Oleh PD/UKPD Lain'},
            {value: '4', text: 'Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain'},
            {value: '5', text: 'Digunakan Instansi/Pihak Lain Seluruhnya'},
        ])
        var dataPdUkpd = ref([])
        var dataPemanfaat = ref([
            {value: null, text: '-- Pilih Salah Satu --'},
            {value: '1', text: 'Pemerintah Pusat'},
            {value: '2', text: 'Pemerintah Daerah Lainnya'},
            {value: '3', text: 'Pihak Lain Selain Pemerintah'},
        ])
        var dataGedungBangunanTanahMilik = ref([
            {value: null, text: '-- Pilih Salah Satu --'},
            {value: '1', text: 'Pemerintah Daerah Provinsi DKI Jakarta'},
            {value: '2', text: 'Pemerintah Pusat'},
            {value: '3', text: 'Pemerintah Daerah Lain'},
            {value: '4', text: 'Pihak Lain'},
        ])
        var dataKabKota = ref([{value: null, text: '-- Pilih Salah Satu --'},])
        var dataKecamatan = ref([{value: null, text: '-- Pilih Salah Satu --'},])
        var dataKelurahan = ref([{value: null, text: '-- Pilih Salah Satu --'},])
        var dataKodePos = ref([{value: null, text: '-- Pilih Salah Satu --'},])
        var dataIndikasiGandaDengan = ref([
            {value: null, text: '-- Pilih Salah Satu --'},
            {value: '1', text: 'Pemerintah Pusat'},
            {value: '2', text: 'Pemerintah Daerah Lain'},
            {value: '3', text: 'PD/UKPD Lain'},
        ])
        var dataIndikasiGandaPdUkpd = ref([])
        var dataIndikasiGandaRegister = ref([{text: '-- Pilih Salah Satu --', value: null}])
        var dataGedungBangunanTanahMilikRegister = ref([{text: '-- Pilih Salah Satu --', value: null}])
        var dataGedungBangunanTanahMilikKobar = ref([{text: '-- Pilih Salah Satu --', value: null}])

        watchEffect(() => {
            kesesuaianBahan.value = (props.kesesuaianBahanVal === '0' || props.kesesuaianBahanVal === '1') ? props.kesesuaianBahanVal : !props.jenisBetonVal ? '0' : ''
            kibSeharusnya.value = props.kibVal

            kesesuaianKodeBarang.value = props.kesesuaianKodeBarangVal
            kibSeharusnya.value = props.kibSeharusnyaVal
            kodeBarangSeharusnya.value = {text: props.kodeBarangSeharusnyaVal, value: props.kodeBarangSeharusnyaVal}
            kesesuaianUkuran.value = props.kesesuaianUkuranVal
            ukuranSeharusnya.value = props.ukuranSeharusnyaVal
            caraPerolehanPenerimaan.value = props.caraPerolehanPenerimaanVal
            isBertingkat.value = props.isBertingkatVal
            bertingkatSeharusnya.value = props.bertingkatSeharusnyaVal
            jumlahSeluruhLantai.value = props.jumlahSeluruhLantaiVal
            isLantaiDigunakan.value = props.isLantaiDigunakanVal
            jumlahLantaiTidakDigunakan.value = props.jumlahLantaiTidakDigunakanVal
            jumlahLantaiDigunakan.value = props.jumlahLantaiDigunakanVal
            bahanSeharusnya.value = props.bahanSeharusnyaVal
            skPenggunaan.value = props.skPenggunaanVal
            nomorSkPenggunaan.value = props.nomorSkPenggunaanVal
            tahunSkPenggunaan.value = props.tahunSkPenggunaanVal
            penggunaan.value = props.penggunaanVal
            gedungBangunanTanahMilik.value = props.gedungBangunanTanahMilikVal
            gedungBangunanTanahMilikPdUkpd.value = props.gedungBangunanTanahMilikPdUkpdVal
            gedungBangunanTanahMilikKobar.value = props.gedungBangunanTanahMilikKobarVal
            gedungBangunanTanahMilikRegister.value = props.gedungBangunanTanahMilikRegisterVal
            gedungBangunanTanahMilikSebutkan.value = props.gedungBangunanTanahMilikSebutkanVal
            kabKota.value = props.kabKotaVal
            kecamatan.value = props.kecamatanVal
            kelurahan.value = props.kelurahanVal
            jalan.value = props.jalanVal
            noAlamat.value = props.noAlamatVal
            rt.value = props.rtVal
            rw.value = props.rwVal
            kodePos.value = props.kodePosVal
            isIndikasiGanda.value = props.isIndikasiGandaVal
            indikasiGandaDengan.value = props.indikasiGandaDenganVal
            indikasiGandaSebutkan.value = props.indikasiGandaSebutkanVal
            indikasiGandaPdUkpd.value = props.indikasiGandaPdUkpdVal
            indikasiGandaKobar.value = props.indikasiGandaKobarVal
            indikasiGandaRegister.value = props.indikasiGandaRegisterVal
        })

        watchEffect(() => {
            digunakanUntuk.value = props.digunakanUntukVal
            pdUkpd.value = props.pdUkpdVal
            pemanfaat.value = props.pemanfaatVal
        })

        watchEffect(() => {
            digunakanBersama.value = props.digunakanBersamaVal
        })

        watch(kabKota, () => {
            getKecamatan()
            getKelurahan()
        })

        const checkField = (val, compareWith) => {
            if(!val && compareWith)
                return false

            return true
        }

        const checkSelectCostum = (val, compareWith) => {
            if(!val.value && compareWith)
                return false

            return true
        }

        const checkLantai = (val) => {
            if(parseInt(val) > parseInt(jumlahSeluruhLantai.value))
                return false
            
            return true
        }

        // validation
        const requiredMsg = 'tidak boleh kosong'
        const $externalResults = ref({})
        const rules = computed(() => ({
            kesesuaianKodeBarang: {
                required: helpers.withMessage('Kesesuaian Kode Barang '+requiredMsg, required)
            },
            kibSeharusnya: {
                checkField: (val) => checkField(val, kesesuaianKodeBarang.value === '0')
            },
            kodeBarangSeharusnya: {
                checkSelectCostum: (val) => checkSelectCostum(val, kesesuaianKodeBarang.value === '0')
            },
            kesesuaianUkuran: {
                required: helpers.withMessage('Kesesuaian Ukuran '+requiredMsg, required)
            },
            ukuranSeharusnya: {
                checkField: (val) => checkField(val, kesesuaianUkuran.value === '0')
            },
            caraPerolehanPenerimaan: {
                required: helpers.withMessage('Cara Perolehan/Penerimaan '+requiredMsg, required)
            },
            isBertingkat: {
                required: helpers.withMessage('Bertingkat '+requiredMsg, required)
            },
            bertingkatSeharusnya: {
                checkField: (val) => checkField(val, isBertingkat.value === '1')
            },
            isLantaiDigunakan: {
                required: helpers.withMessage('Lantai Digunakan '+requiredMsg, required)
            },
            jumlahSeluruhLantai: {
                checkField: (val) => checkField(val, isLantaiDigunakan.value === '1')
            },
            jumlahLantaiDigunakan: {
                checkField: (val) => checkField(val, isLantaiDigunakan.value === '1'),
                checkLantai
            },
            jumlahLantaiTidakDigunakan: {
                checkField: (val) => checkField(val, isLantaiDigunakan.value === '1')
            },
            kesesuaianBahan: {
                required: helpers.withMessage('Kesesuaian Bahan '+requiredMsg, required)
            },
            bahanSeharusnya: {
                checkField: (val) => checkField(val, kesesuaianBahan.value === '0')
            },
            skPenggunaan: {
                required: helpers.withMessage('SK Penggunaan '+requiredMsg, required)
            },
            nomorSkPenggunaan: {
                checkField: (val) => checkField(val, skPenggunaan.value === '1')
            },
            tahunSkPenggunaan: {
                checkField: (val) => checkField(val, skPenggunaan.value === '1')
            },
            penggunaan: {
                required: helpers.withMessage('Penggunaan '+requiredMsg, required)
            },
            // digunakanUntuk: {
            //     checkField: (val) => checkField(val, penggunaan.value === '2' || penggunaan.value === '3' || penggunaan.value === '4')
            // },
            // pdUkpd: {
            //     checkSelectCostum: (val) => checkSelectCostum(val, penggunaan.value === '3' || penggunaan.value === '4'),
            // },
            pdUkpd: {
                $each: helpers.forEach({
                    value: {
                        checkSelectCostum: (val) => checkSelectCostum(val, penggunaan.value === '3' || penggunaan.value === '4'),
                    },
                })
            },
            digunakanUntuk: {
                $each: helpers.forEach({
                    value: {
                        checkField: (val) => checkField(val, penggunaan.value === '2' || penggunaan.value === '3' || penggunaan.value === '4')
                    },
                })
            },
            // pemanfaat: {
            //     checkField: (val) => checkField(val, penggunaan.value === '4' || penggunaan.value === '5')
            // },
            pemanfaat: {
                $each: helpers.forEach({
                    value: {
                        checkField: (val) => checkField(val, penggunaan.value === '4' || penggunaan.value === '5')
                    },
                    namaPemanfaat: {
                        checkField: (val) => checkField(val, pemanfaat.value === '1' || pemanfaat.value === '2' || pemanfaat.value === '3')
                    },
                    dasarPenggunaan: {
                        checkField: (val) => checkField(val, pemanfaat.value === '1' || pemanfaat.value === '2' || pemanfaat.value === '3')
                    },
                    dasarPenggunaanTipe: {
                        checkField: (val) => checkField(val, pemanfaat.value === '3' && dasarPenggunaan.value == '1')
                    }
                })
            },
            // namaPemanfaat: {
            //     checkField: (val) => checkField(val, pemanfaat.value === '1' || pemanfaat.value === '2' || pemanfaat.value === '3')
            // },
            // dasarPenggunaan: {
            //     checkField: (val) => checkField(val, pemanfaat.value === '1' || pemanfaat.value === '2' || pemanfaat.value === '3')
            // },
            // dasarPenggunaanTipe: {
            //     checkField: (val) => checkField(val, pemanfaat.value === '3' && dasarPenggunaan.value == '1')
            // },
            gedungBangunanTanahMilik: {
                required: helpers.withMessage('Gedung dan Bangunan di Atas Tanah Milik '+requiredMsg, required)
            },
            gedungBangunanTanahMilikPdUkpd: {
                checkSelectCostum: (val) => checkSelectCostum(val, gedungBangunanTanahMilik.value === '1'),
            },
            gedungBangunanTanahMilikKobar: {
                checkSelectCostum: (val) => checkSelectCostum(val, gedungBangunanTanahMilik.value === '1'),
            },
            gedungBangunanTanahMilikRegister: {
                checkField: (val) => checkField(val, gedungBangunanTanahMilik.value === '1')
            },
            gedungBangunanTanahMilikSebutkan: {
                checkField: (val) => checkField(val, gedungBangunanTanahMilik.value === '2' || gedungBangunanTanahMilik.value === '3' || gedungBangunanTanahMilik.value === '4')
            },
            kesesuaianAlamat: {
                // required: helpers.withMessage('Gedung dan Bangunan di Atas Tanah Milik '+requiredMsg, required)
            },
            kabKota: {
                checkField: (val) => checkField(val, true)
            },
            kecamatan: {
                checkField: (val) => checkField(val, true)
            },
            kelurahan: {
                checkField: (val) => checkField(val, true)
            },
            jalan: {
                checkField: (val) => checkField(val, true)
            },
            noAlamat: {
                // checkField: (val) => checkField(val)
            },
            rt: {
                checkField: (val) => checkField(val, true)
            },
            rw: {
                checkField: (val) => checkField(val, true)
            },
            kodePos: {
                checkField: (val) => checkField(val, true)
            },
            isIndikasiGanda: {
                required: helpers.withMessage('Indikasi Tercatat Ganda '+requiredMsg, required)
            },
            indikasiGandaDengan: {
                checkField: (val) => checkField(val, isIndikasiGanda.value === '1')
            },
            indikasiGandaSebutkan: {
                checkField: (val) => checkField(val, indikasiGandaDengan.value === '1' || indikasiGandaDengan.value === '2')
            },
            indikasiGandaPdUkpd: {
                checkSelectCostum: (val) => checkSelectCostum(val, indikasiGandaDengan.value === '3'),
            },
            indikasiGandaKobar: {
                checkSelectCostum: (val) => checkSelectCostum(val, indikasiGandaDengan.value === '3')
            },
            indikasiGandaRegister: {
                checkField: (val) => checkField(val, indikasiGandaDengan.value === '3')
            },
        }))

        const v$ = useVuelidate(rules, { kesesuaianKodeBarang, kodeBarangSeharusnya, kesesuaianUkuran, ukuranSeharusnya, isBertingkat, caraPerolehanPenerimaan, bertingkatSeharusnya, isLantaiDigunakan, jumlahSeluruhLantai, jumlahLantaiDigunakan, jumlahLantaiTidakDigunakan, kesesuaianBahan, bahanSeharusnya, skPenggunaan, nomorSkPenggunaan, tahunSkPenggunaan, penggunaan, digunakanUntuk, pdUkpd, pemanfaat, gedungBangunanTanahMilik, gedungBangunanTanahMilikPdUkpd, gedungBangunanTanahMilikKobar, gedungBangunanTanahMilikRegister, gedungBangunanTanahMilikSebutkan, kesesuaianAlamat, kabKota, kecamatan, kelurahan, jalan, noAlamat, rt, rw, kodePos, isIndikasiGanda, indikasiGandaDengan, indikasiGandaSebutkan, indikasiGandaPdUkpd, indikasiGandaKobar, indikasiGandaRegister, kibSeharusnya }, {$externalResults, $autoDirty: true})

        const submitForm = async () => {
            isSubmit.value = true
            const isFormCorrect = await v$.value.$validate()
            // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
            //jika error validasi
            console.log(isFormCorrect);
            console.log(v$.value);
            if (!isFormCorrect) {
                isSubmit.value = false
                return
            }

            let data = {
                id: props.id,
                di_m_kobar: kesesuaianKodeBarang.value,
                di_m_ukuran: kesesuaianUkuran.value,
                di_cara_perolehan: caraPerolehanPenerimaan.value,
                di_m_bertingkat: isBertingkat.value,
                di_m_bertingkat_a: bertingkatSeharusnya.value,
                di_m_lantai_tdk: isLantaiDigunakan.value,
                di_m_beton: kesesuaianBahan.value,
                di_m_sk_penggunaan: skPenggunaan.value,
                di_penggunaan: penggunaan.value,
                di_gedung_bangunan_diatas_tanah_milik: gedungBangunanTanahMilik.value,
                di_m_alamat: kesesuaianAlamat.value,
                di_indikasi_ganda: isIndikasiGanda.value,
                di_kd_rayon: kabKota.value,
                di_kd_kec: kecamatan.value,
                di_kd_kel: kelurahan.value,
                di_jalan: jalan.value,
                di_no_jalan: noAlamat.value,
                di_rt: rt.value,
                di_rw: rw.value,
                di_kodepos: kodePos.value,
                
                // 
                // di_dokumen_kepemilikan_tanah:
                // di_dokumen_kepemilikan_tanah_ser:
                // di_dokumen_kepemilikan_tanah_no_ser:
                // di_dokumen_kepemilikan_tanah_kelurahan_ser:
                // di_dokumen_kepemilikan_tanah_ukuran_ser:
                // di_dokumen_kepemilikan_tanah_selain:
                // di_penetapan_dokumen:
                // di_permasalahan_tanah:
                // di_permasalahan_tanah_sebutkan:
                // 
                
                
                
                // di_jenis_perkerasan_jalan:
                // di_jenis_perkerasan_jalan_sebutkan:
                // di_jenis_bahan_struktur_jembatan:
                // di_jenis_bahan_struktur_jembatan_sebutkan:
                // di_no_ruas_jalan:
                // di_jalan_diatas_tanah_milik:
                // di_jalan_diatas_tanah_milik_sebutkan:
            }

            if(kesesuaianKodeBarang.value === '0'){
                data.di_m_kobar_a = kodeBarangSeharusnya.value.value
                data.di_m_nabar_a = namaBarangSeharusnya.value
                data.di_m_kobar_kib = kibSeharusnya.value
            }

            if(kesesuaianUkuran.value === '0')
                data.di_m_ukuran_a = ukuranSeharusnya.value

            if(isLantaiDigunakan.value === '1'){
                data.di_m_lantai_tdk_all = jumlahSeluruhLantai.value
                data.di_m_lantai_tdk_use = jumlahLantaiDigunakan.value
                data.di_m_lantai_tdk_not = jumlahLantaiTidakDigunakan.value
            }

            if(kesesuaianBahan.value === '0')
                data.di_m_beton_a = bahanSeharusnya.value

            if(skPenggunaan.value === '1'){
                data.di_sk_penggunaan_no = nomorSkPenggunaan.value
                data.di_sk_penggunaan_tahun = tahunSkPenggunaan.value
            }

            if(penggunaan.value === '2' || penggunaan.value === '3' || penggunaan.value === '4')
                data.di_penggunaan_untuk = [digunakanUntuk.value[0].value]

            if(penggunaan.value === '3' || penggunaan.value === '4')
                data.di_penggunaan_opd = [pdUkpd.value[0].value.value]

            if(penggunaan.value === '4'){
                if(digunakanBersama.value.includes('1')){
                    data.di_penggunaan_opd = pdUkpd.value.map(item => item.value.value)
                    data.di_penggunaan_untuk = digunakanUntuk.value.map(item => item.value)
                }

                if(digunakanBersama.value.includes('0')){
                    let listPemanfaat = []
                    let listNamaPemanfaat = []
                    let listDasarPenggunaan = []
                    let listDasarPenggunaanTipe = []

                    for (let i = 0; i < pemanfaat.value.length; i++) {
                        const {value, namaPemanfaat, dasarPenggunaan, dasarPenggunaanTipe} = pemanfaat.value[i];
                        
                        listPemanfaat.push(value)
                        listNamaPemanfaat.push(namaPemanfaat)
                        listDasarPenggunaan.push(dasarPenggunaan)
                        listDasarPenggunaanTipe.push(dasarPenggunaanTipe ?? null)
                    }

                    data.di_penggunaan_pemanfaat = listPemanfaat
                    data.di_penggunaan_pemanfaat_nama = listNamaPemanfaat
                    data.di_penggunaan_pemanfaat_dasar = listDasarPenggunaan
                    data.di_penggunaan_pemanfaat_dasar_type = listDasarPenggunaanTipe
                }
            }

            if(penggunaan.value === '5'){
                let listPemanfaat = []
                let listNamaPemanfaat = []
                let listDasarPenggunaan = []
                let listDasarPenggunaanTipe = []

                for (let i = 0; i < pemanfaat.value.length; i++) {
                    const {value, namaPemanfaat, dasarPenggunaan, dasarPenggunaanTipe} = pemanfaat.value[i];
                    
                    listPemanfaat.push(value)
                    listNamaPemanfaat.push(namaPemanfaat)
                    listDasarPenggunaan.push(dasarPenggunaan)
                    listDasarPenggunaanTipe.push(dasarPenggunaanTipe ?? null)
                }

                data.di_penggunaan_pemanfaat = listPemanfaat
                data.di_penggunaan_pemanfaat_nama = listNamaPemanfaat
                data.di_penggunaan_pemanfaat_dasar = listDasarPenggunaan
                data.di_penggunaan_pemanfaat_dasar_type = listDasarPenggunaanTipe
            }

            if(gedungBangunanTanahMilik.value === '1'){
                data.di_gedung_bangunan_diatas_tanah_milik_opd = gedungBangunanTanahMilikPdUkpd.value.value
                data.di_gedung_bangunan_diatas_tanah_milik_kobar = gedungBangunanTanahMilikKobar.value.value
                data.di_gedung_bangunan_diatas_tanah_milik_noreg = gedungBangunanTanahMilikRegister.value
            }
            else if(gedungBangunanTanahMilik.value === '2' || gedungBangunanTanahMilik.value === '3' || gedungBangunanTanahMilik.value === '4')
                data.di_gedung_bangunan_diatas_tanah_milik_sebut = gedungBangunanTanahMilikSebutkan.value

            if(isIndikasiGanda.value === '1')
                data.di_indikasi_ganda_dengan = indikasiGandaDengan.value

            if(indikasiGandaDengan.value === '1' || indikasiGandaDengan.value === '2')
                data.di_indikasi_ganda_sebutkan = indikasiGandaSebutkan.value

            if(indikasiGandaDengan.value === '3'){
                data.di_indikasi_ganda_opd = indikasiGandaPdUkpd.value.value
                data.di_indikasi_ganda_kobar = indikasiGandaKobar.value.value
                data.di_indikasi_ganda_register = indikasiGandaRegister.value
            }

            await dataInformasi.submit(g, data)
            isSubmit.value = false
        }

        const getCaraPerolehan = async () => {
            let resCaraPerolehan = await master.getCaraPerolehan(g);

            resCaraPerolehan.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataCaraPerolehanPenerimaan.value = resCaraPerolehan
        }

        const getTingkat = async () => {
            let resGetTingkat = await master.getTingkat(g);

            resGetTingkat.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataBertingkatSeharusnya.value = resGetTingkat
        }

        const getPdUkpd = async (searchPdUpd = '') => {
            let params = {
                tahun: tahunNow.value,
                cari: searchPdUpd,
            }
            let resPdUkpd = await master.getPdUpd(g, params)
            resPdUkpd.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataPdUkpd.value = resPdUkpd
            dataIndikasiGandaPdUkpd.value = resPdUkpd
        }

        const getKabKota = async () => {
            let params = {
                provinsi: '01'
            }
            let resKota = await master.getKota(g, params)
            resKota.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataKabKota.value = resKota
        }

        const getKecamatan = async () => {
            let params = {
                provinsi: '01',
                kota: kabKota.value
            }
            let resKecamatan = await master.getKecamatan(g, params)
            resKecamatan.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataKecamatan.value = resKecamatan
        }

        const getKelurahan = async () => {
            let params = {
                provinsi: '01',
                kota: kabKota.value,
                kecamatan: kecamatan.value
            }
            let resKelurahan = await master.getKelurahan(g, params)
            resKelurahan.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataKelurahan.value = resKelurahan
        }

        const getKib = async () => {
            let resKib = await master.getKib(g)
            resKib.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataKib.value = resKib
        }

        const getKobar = async (kobar = '', kolok = null) => {
            let params = {
                kib: kibSeharusnya.value ? kibSeharusnya.value : props.kibVal,
                cari: kobar,
                kolok
            }
            let resKobar = await master.getKobar(g, params)
            
            resKobar = resKobar.rows.map((data, i) => {
                return {
                    text: `${data.kode} :: ${data.nama}`,
                    value: data.kode,
                    nama: data.nama
                }
            })
            resKobar.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataKobar.value = resKobar
        }

        const getKobar2 = async (kobar = '', kolok = null) => {
            let params = {
                kib: 'A',
                cari: kobar,
                kolok
            }
            let resKobar = await master.getKobar(g, params)
            
            resKobar = resKobar.rows.map((data, i) => {
                return {
                    text: `${data.kode} :: ${data.nama}`,
                    value: data.kode,
                    nama: data.nama
                }
            })
            resKobar.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataGedungBangunanTanahMilikKobar.value = resKobar
        }

        const getNoReg = async () => {
            let params = {
                kib: kibSeharusnya.value ? kibSeharusnya.value : props.kibVal,
                tahun_rekon: props.rekonTahunVal,
                kode_rekon: props.rekonKodeVal,
                kobar: indikasiGandaKobar.value.value,
                kolok: indikasiGandaPdUkpd.value ?? indikasiGandaPdUkpd.value ? indikasiGandaPdUkpd.value.value : null
            }
            let resNoReg = await master.getNoReg(g, params)
            resNoReg = resNoReg.rows.map((data, i) => {
                return {
                    text: data.noreg_108 + ' :: ' + data.ALAMAT,
                    value: data.noreg_108,
                }
            })
            resNoReg.unshift({text: '-- Pilih Salah Satu --', value: null})
            dataIndikasiGandaRegister.value = resNoReg
        }

        const getNoReg2 = async () => {
            let params = {
                kib: 'A',
                tahun_rekon: props.rekonTahunVal,
                kode_rekon: props.rekonKodeVal,
                kolok: gedungBangunanTanahMilikPdUkpd.value.value,
                kobar: gedungBangunanTanahMilikKobar.value ?? gedungBangunanTanahMilikKobar.value ? gedungBangunanTanahMilikKobar.value.value : null
            }
            let resNoReg = await master.getNoReg(g, params)
            if(resNoReg.rows){
                resNoReg = resNoReg.rows.map((data, i) => {
                    return {
                        text: data.noreg_108 + ' :: ' + data.ALAMAT,
                        value: data.noreg_108,
                    }
                })
                resNoReg.unshift({text: '-- Pilih Salah Satu --', value: null})
                dataGedungBangunanTanahMilikRegister.value = resNoReg
            }
        }

        const changeKabKota = () => {
            getKecamatan()
            kecamatan.value = null
        }

        const changeKecamatan = () => {
            getKelurahan()
            kelurahan.value = null
        }

        const changeKelurahan = () => {
            let index = dataKelurahan.value.findIndex(x => x.value === kelurahan.value)
            kodePos.value = dataKelurahan.value[index].kodepos
        }

        const changeIndikasiGandaDengan = () => {
            if(indikasiGandaDengan.value == 3)
                getKobar('', indikasiGandaPdUkpd.value ?? indikasiGandaPdUkpd.value ? indikasiGandaPdUkpd.value.value : null)
        }

        const changeKibSeharusnya = () => {
            getKobar()
            kodeBarangSeharusnya.value = {value: null, text: '-- Pilih Salah Satu --'}
        }

        const changeKesesuaianBarang = () => {
            getKobar()
        }

        const searchKodeBarangSeharusnya = search => {
            getKobar(search)
        }

        const inputKodeBarangSeharusnya = () => {
            namaBarangSeharusnya.value = kodeBarangSeharusnya.value.nama
        }

        const keyUpLantai = () => {
            jumlahLantaiTidakDigunakan.value = (jumlahSeluruhLantai.value - jumlahLantaiDigunakan.value).toString()
        }

        const searchIndikasiGandaKobar = search => {
            getKobar(search)
        }

        const inputIndikasiGandaKobar = () => {
            getNoReg()
        }

        const changeBertingkatSeharusnya = () => {
            jumlahSeluruhLantai.value = bertingkatSeharusnya.value - (-1)
        }

        const inputGedungBangunanTanahMilikPdUkpd = () => {
            getKobar2('', gedungBangunanTanahMilikPdUkpd.value ?? gedungBangunanTanahMilikPdUkpd.value ? gedungBangunanTanahMilikPdUkpd.value.value : null)
        }

        const inputGedungBangunanTanahMilikKobar = () => {
            getNoReg2()
        }

        const validateState = (item) => {
            const { $dirty, $error } = item
            return !$dirty ? null : $error ? false : null
        }

        const changeIntOnly = (evt) => {
            setInputIntOnly(evt)
        }

        const resetForm = () => {
            
        }

        const validateState2 = (item) => {
            const { $error } = item
            return $error ? false : null
        }

        getCaraPerolehan()
        getTingkat()
        getKabKota()
        getKib()
        getPdUkpd()
        getNoReg2()

        return {
            v$, $externalResults, isSubmit, defaultKolok,
            //variable string, int
            kesesuaianKodeBarang, kibSeharusnya, kodeBarangSeharusnya, namaBarangSeharusnya, kesesuaianUkuran, ukuranSeharusnya, caraPerolehanPenerimaan, isBertingkat, bertingkatSeharusnya, isLantaiDigunakan, jumlahSeluruhLantai, jumlahLantaiDigunakan, jumlahLantaiTidakDigunakan, kesesuaianBahan, bahanSeharusnya, skPenggunaan, nomorSkPenggunaan, tahunSkPenggunaan, penggunaan, digunakanUntuk, pdUkpd, pemanfaat, gedungBangunanTanahMilik, gedungBangunanTanahMilikSebutkan, kesesuaianAlamat, kabKota, kecamatan, kelurahan, jalan, noAlamat, rt, rw, kodePos, isIndikasiGanda, indikasiGandaDengan, indikasiGandaSebutkan, indikasiGandaPdUkpd, indikasiGandaKobar, indikasiGandaRegister, gedungBangunanTanahMilikPdUkpd, gedungBangunanTanahMilikKobar, gedungBangunanTanahMilikRegister,
            //variable array
            dataKib, dataKobar, dataCaraPerolehanPenerimaan, dataBertingkatSeharusnya, dataBahanSeharusnya, dataPenggunaan, dataPdUkpd, dataPemanfaat, dataGedungBangunanTanahMilik, dataKabKota, dataKecamatan, dataKelurahan, dataKodePos, dataIndikasiGandaDengan, dataIndikasiGandaPdUkpd, dataIndikasiGandaRegister, dataGedungBangunanTanahMilikRegister, dataGedungBangunanTanahMilikKobar,
            //variable func
            resetForm, validateState, submitForm, changeIntOnly, changeKabKota, changeKecamatan, changeKelurahan, changeIndikasiGandaDengan, changeKibSeharusnya, changeKesesuaianBarang, searchKodeBarangSeharusnya, inputKodeBarangSeharusnya, keyUpLantai, inputIndikasiGandaKobar, searchIndikasiGandaKobar, validateState2, changeBertingkatSeharusnya, digunakanBersama, inputGedungBangunanTanahMilikPdUkpd, inputGedungBangunanTanahMilikKobar
        }
    },
    directives: {
        Ripple,
    },
    components: {
        vSelect,
        BCard, BForm, BFormRow, BCol, BFormInput, BFormValidFeedback, BFormInvalidFeedback, BCardHeader, BCardBody, BButton, BFormGroup, BCardTitle, BSpinner, BFormSelect, BTable, BRow, BFormTextarea
    },
}
</script>

<style lang="scss" scope>
@import '@core/scss/vue/libs/vue-select.scss';
</style>